import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconContractLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.2197 5.46967C10.5126 5.17678 10.9874 5.17678 11.2803 5.46967C11.5732 5.76256 11.5732 6.23744 11.2803 6.53033L5.81066 12L11.2803 17.4697C11.5732 17.7626 11.5732 18.2374 11.2803 18.5303C10.9874 18.8232 10.5126 18.8232 10.2197 18.5303L4.21967 12.5303C3.92678 12.2374 3.92678 11.7626 4.21967 11.4697L10.2197 5.46967Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.2197 5.46967C18.5126 5.17678 18.9874 5.17678 19.2803 5.46967C19.5732 5.76256 19.5732 6.23744 19.2803 6.53033L13.8107 12L19.2803 17.4697C19.5732 17.7626 19.5732 18.2374 19.2803 18.5303C18.9874 18.8232 18.5126 18.8232 18.2197 18.5303L12.2197 12.5303C11.9268 12.2374 11.9268 11.7626 12.2197 11.4697L18.2197 5.46967Z",
		fill: "currentColor"
	})]
});
export { SvgIconContractLeft as ReactComponent };
